import React, { Component } from "react";
import "./stylesheets/customer.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackSiteid,
  getBackAllCustomer,
  getBackCustmor,
  addCustomer,
  deleteSiteCustomer,
  deleteCustomer,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import { Button, Dropdown, Offcanvas } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";

export default class Customer extends Component {
  constructor(props) {
    super(props);
    this.wrapper = React.createRef();
    this.state = {
      showData: false,
      scroll: false,
      backdrop: false,
      name: "Job",
      placement: "end",
      customerdetails: [],
      CustomerID: 0,
      CustomerName: "",
      listCustomer: [],
      siteId: 0,
      selectedSite: "Site Id",
      listSiteId: "",
      isError: {
        CustomerName: "",
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    var sendData = {
      userid: userId,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendData);
      const datarespsites = await responsesites;

      const responseCustomer = await getBackAllCustomer();
      const datarespCustomer = await responseCustomer;

      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }
      var customerListArr = [];
      for (var i = 0; i < datarespCustomer.length; i++) {
        var customerList = {};
        customerList.value = datarespCustomer[i].CustomerCode;
        customerList.label = datarespCustomer[i].CustomerName;
        customerListArr.push(customerList);
      }
      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        siteId: siteIdArr[0].key,
        listCustomer:
          selectedTenantData.Tenant === "Thisco" ? [] : customerListArr,
      });
    };
    fetchsiteid();
  }

  handleClose = (event) => {
    this.setState({ showData: false });
  };

  handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleDataChangeDrop = (event) => {
    this.setState({
      CustomerName: event,
    });
  };
  handleShow = (event, row) => {
    this.setState({ showData: true, customer: event });
  };

  handleDropdownSite = (key, event) => {
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      customerdetails: [],
      showData: false,
    });
  };

  handleInputFetch = (event) => {
    var loadingData = "No data Found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    const siteId = this.state.siteId;
    var sendData = {
      site_id: siteId,
    };
    const fetchCustomerdetails = async () => {
      const responseCustomer = await getBackCustmor(sendData);
      const datarespCustomer = await responseCustomer;
      if (datarespCustomer.length > 0) {
        this.setState({
          loading: false,
          loadingData: loadingData,
        });
      } else {
        loadingData = "No data found";
      }
      this.setState({
        customerdetails: datarespCustomer,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchCustomerdetails();
  };

  handleAddCustomer = (event) => {
    let isError = this.state.isError;
    event.preventDefault();
    if (this.state.CustomerName === "") {
      isError["CustomerName"] = "Please select customer";
      this.setState({ isError });
    } else {
      var submitData = {
        SiteID: this.state.siteId,
        CustomerName: this.state.CustomerName.label,
      };
      const CustomerAdd = async () => {
        const responsesites = await addCustomer(submitData);
        this.handleInputFetch();
        this.CustomerAdd({ showData: false });
      };
      CustomerAdd();
    }
  };

  handleDeleteSiteCustomer = (event) => {
    var submitData = {
      SiteID: event.SiteID,
      customerId: event.CustomerID,
    };

    const CustomerDeleteSite = async () => {
      const responsesites = await deleteSiteCustomer(submitData);
      this.handleInputFetch();
    };
    var msg = "You want to delete this customer !";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        CustomerDeleteSite();
      }
    });
  };

  handleDeleteCustomer = (event) => {
    var submitData = {
      SiteID: event.SiteID,
      customerId: event.CustomerID,
    };

    const CustomerDelete = async () => {
      const responsesites = await deleteCustomer(submitData);
      this.handleInputFetch();
      this.CustomerAdd({ showData: false });
    };
    var msg = "You want to delete this customer !";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        CustomerDelete();
      }
    });
  };

  render() {
    const options = this.state.listCustomer;
    const addUserLogo = require("../../../assets/images/add_user.png");
    const terminationLogo = require("../../../assets/images/termination.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");

    var listSiteId = this.state.listSiteId;
    const columns = [
      {
        dataField: "CustomerSiteID",
        text: "Customer Id",
      },
      {
        dataField: "CustomerName",
        text: "Name",
      },
      {
        dataField: "Action",
        text: "Action",
        classes: "actionbtncustm",
        isDummyField: true,
        editable: false,
        formatter: (cellContent, row) => {
          return (
            <span>
              <span className="saveBtnUs">
                <img
                  src={terminationLogo}
                  alt="logo"
                  className="logo-user"
                  title="Disable Customer"
                  onClick={() => {
                    this.handleDeleteSiteCustomer(row);
                  }}
                />
              </span>
            </span>
          );
        },
      },
    ];
    var products = this.state.customerdetails;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-user">
            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
          </div>
          <div className="submiteditbtncustm">
            <img
              src={addUserLogo}
              alt="logo"
              className="logo-add-user"
              title="Add Customer"
              onClick={() => {
                this.handleShow("Add Customer");
              }}
            />
          </div>
        </div>
        <div className="table-container-user">
          <BootstrapTable
            classes="tabledata-user"
            keyField="JobID"
            id="tabledata"
            data={products}
            columns={columns}
            noDataIndication="No data found"
          />
        </div>
        <Offcanvas
          className="useroff"
          show={this.state.showData}
          scroll={this.state.scroll}
          name={this.state.name}
          backdrop={this.state.backdrop}
          placement={this.state.placement}
          onHide={this.handleClose}
        >
          <Offcanvas.Header className="popup_header" closeButton>
            <Offcanvas.Title className="header_title">
              <span className="title_contant">{this.state.customer}</span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container">
              <div className="rowUser justify-content-center">
                <div className="col-md-12">
                  <form
                    className="pr-5 mb-5 formUser"
                    method="POST"
                    onSubmit={this.handleAddCustomer}
                  >
                    <div className="rowUser">
                      <div className="col-md-12 form-group input-user">
                        <Select
                          onChange={this.handleDataChangeDrop}
                          value={this.state.CustomerName}
                          options={options}
                          className="font_size"
                          placeholder="Select Customer"
                          required
                        />
                        {this.state.isError.CustomerName !== "" ? (
                          <span className="tool_tip">
                            {this.state.isError.CustomerName}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="edit_input submitbtn mt-3">
                      <button
                        type="submit"
                        className="btnval btn btn-success font_size"
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        onClick={this.handleClose}
                        className="btnval btn btn-warning font_size"
                      >
                        Discard
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        {this.state.loading === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
